import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionResultsMetadataMap } from "components/BulkActions/helpers";
import {
  BulkActionResultTabs,
  BulkActionsResult,
  BulkActionsStep,
} from "components/BulkActions/types";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";

import { getRunLink } from "./helpers";
import { BulkItemRunWithPosition } from "./types";

type WorkerPoolQueuedRunsBulkActionsResultItemProps = {
  item: BulkItemRunWithPosition;
  tab: BulkActionResultTabs;
  resultsMetadata: BulkActionResultsMetadataMap;
  status: BulkActionsResult;
  stopExecution: () => void;
};

const WorkerPoolQueuedRunsBulkActionsResultItem = ({
  item,
  tab,
  resultsMetadata,
  status,
  stopExecution,
}: WorkerPoolQueuedRunsBulkActionsResultItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";

  return (
    <BulkActionsDrawerItem key={item.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        <BulkActionsDrawerItemLink
          link={getRunLink(item)}
          text={item.run.title}
          step={BulkActionsStep.Results}
          itemCategory={tab}
        />
        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata.get(item.id)?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.get(item.id)?.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default WorkerPoolQueuedRunsBulkActionsResultItem;
